<script setup lang="ts">
import { toSizeName } from "core/helpers";

import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useModalStore } from "~/stores/modal";
import { useSizesStore } from "~/stores/sizes";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { sizesConfirmDelete } = useModalStore();
const sizesStore = useSizesStore();

const submitSizeDelete = async () => {
	await sizesStore.deleteById(sizesConfirmDelete.size.id);

	sizesConfirmDelete.closeModal();

	if (route.name === "components-sizes-size") {
		navigateTo("/components/sizes");
	} else if (route.name === "components-sizes") {
		sizesStore.getAll({}, sizesStore.recentGetAllQuery);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.SIZES.CONFIRM_DELETE.alert.title"),
		description: t("COMPONENTS.SIZES.CONFIRM_DELETE.alert.description", { sizeName: toSizeName(sizesConfirmDelete.size) }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.SIZES.CONFIRM_DELETE.title')"
		:description="$t('COMPONENTS.SIZES.CONFIRM_DELETE.description', { sizeName: toSizeName(sizesConfirmDelete.size) })"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="sizesConfirmDelete.closeModal"
		@submit="submitSizeDelete"
	/>
</template>
